import { Auth } from 'aws-amplify';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router';
import { logout } from '../../../features/player/playerSlice';

const ProfileMenuExit = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	return (
		<div
			className="profile-menu-exit d-flex f-row pointer"
			onClick={() => {
				Auth.signOut();
				navigate('/');
				dispatch(logout());
			}}
		>
			<div>
				<FormattedMessage id="exit" />
			</div>
			<div>
				<img src="/images/14esci_gr.png" className="ico16px" />
			</div>
		</div>
	);
};

export default ProfileMenuExit;
